import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Box, Tooltip, Typography } from '@mui/material';

import { colors } from '@/theme/variables';

type LinkedCase = { _id: string; number: string };

export const LinkedCasesCell: FC<{
  cases?: LinkedCase[];
  fontSize?: number;
}> = ({ cases, fontSize = 14 }) => {
  if (!cases?.length) return null;
  const [first, ...rest] = cases;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Link
        to={`/cases/${first._id}/overview`}
        onClick={(e) => e.stopPropagation()}
        style={{
          textDecoration: 'underline',
          color: colors.error.main,
          fontSize,
        }}
      >
        {first.number}
      </Link>
      {rest.length > 0 && (
        <Tooltip title={rest.map((c) => c.number).join(', ')} arrow>
          <Typography
            sx={{ fontSize: `${fontSize}px`, color: 'text.secondary' }}
          >
            +{rest.length}
          </Typography>
        </Tooltip>
      )}
    </Box>
  );
};
